import{Auth as r}from"./auth.js";var o=new r;export{o as AuthInstance};
//# sourceMappingURL=authSingleton.js.map
